import {
  Flex,
  Link,
  Text,
  Box,
  useBreakpointValue,
  Tooltip,
  Icon,
  Spinner,
} from "@chakra-ui/react";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import React, { useState, useEffect } from "react";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { RiFileExcel2Line } from "react-icons/ri";
import { Link as ReactLink, useHistory } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import CriancaService from "../../../../main/services/CriancaService";

import { handleVerifyRedirectPendencia } from "../../../utils/hadleVerifyRedirectPendencia";
import SemRegistros from "../../../components/SemRegistros";
import { PopoverGenero } from "../../../components/PopoverGenero";
import { IoHelpCircle } from "react-icons/io5";
import {
  criancaFunc,
  dashboardFunc,
  Permission,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import { TableCriancas } from "../../../components/TableCriancas";
import Swal from "sweetalert2";
import RelatorioService from "../../../../main/services/RelatorioService";

export default function DashboardCriancaPendencia() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const { roleKeycloack, user, selectedProfile, selectedOrgao } = useAuthProvider();
  const history = useHistory();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [hintPreliminar, setHintPreliminar] = useState(false);
  const placement = useBreakpointValue({ md: "right" });
  const [atualizarDadosTabela, setAtualizarDadosTabela] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);

  const riscoAlert = (id, idPJCrianca, idMovimento) => {
    if (
      idMovimento !== 2 &&
      !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
      !(
        (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJCrianca)
      )
    ) {
      Swal.fire({
        title: "Por favor, entre em contato com o Gestor do MCA.",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: "#169499",
        cancelButtonText: "Voltar",
      });
    } else {
      history.push("/crianca/" + id);
    }
  };

  const columns = [
    {
      Header: "Nome/Nome Social",
      accessor: "nomeCrianca",
      Cell: (props) => {
        const id = props?.row?.original?.idCrianca;
        let name = props?.row?.original?.nomeCrianca;
        let ultimaMovimentacao = props?.row?.original?.movimentacoes[0];

        let temRiscoVida = false;
        let ultimaMovimentacaoRisco;

        if (ultimaMovimentacao?.idMovimento !== 2) {
          ultimaMovimentacaoRisco = props?.row?.original?.movimentacoes[0];
        }

        if (props?.row?.original?.nomeSocial) {
          name = name + " / " + props.row.original.nomeSocial;
        }

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        return (roleKeycloack &&
          roleKeycloack.includes(criancaFunc.visualizar)) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM
          ) ? (
          (ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao === "N" ||
            !ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao) &&
          !temRiscoVida ? (
            <Link
              wordBreak={"break-all"}
              title={name}
              as={ReactLink}
              to={"/crianca/" + id}
            >
              <Flex alignItems="center" gap={2}>
                {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" &&
                ultimaMovimentacao?.idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          ) : (
            <Link
              wordBreak={"break-all"}
              title={name}
              onClick={() =>
                riscoAlert(
                  id,
                  props?.row?.original?.servicoAcolhimento?.idPessoaJuridica,
                  props?.row?.original?.movimentacoes[0]?.idMovimento
                )
              }
            >
              <Flex alignItems="center" gap={2}>
                {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" &&
                ultimaMovimentacao?.idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          )
        ) : ultimaMovimentacao?.riscoVidaMotivoSituacao === "N" ||
          !ultimaMovimentacao?.riscoVidaMotivoSituacao ? (
          <Flex alignItems="center" gap={2}>
            {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
            ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                F
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        ) : (
          <Flex alignItems="center" gap={2}>
            {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
            ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        );
      },
    },
    {
      Header: "Idade",
      accessor: "idadeCrianca",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
    {
      Header: "Filiação",
      accessor: "pais",
      sortType: (rowA, rowB, id, desc) => {
        const filiacoesA = rowA?.original?.filiacoes?.length
          ? rowA.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        const filiacoesB = rowB?.original?.filiacoes?.length
          ? rowB.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        return filiacoesA.localeCompare(filiacoesB, "pt-BR");
      },
      Cell: (props) => {
        return props?.value
          .sort((a, b) =>
            a.descricaoTipoRelacionamento.localeCompare(
              b.descricaoTipoRelacionamento
            )
          )
          .map((filiacao, index) => {
            return (
              <React.Fragment key={index}>
                <span style={{ whiteSpace: "nowrap" }}>
                  {filiacao?.nome}{" "}
                  <Text as="span" textTransform="capitalize">
                    ({filiacao?.descricaoTipoRelacionamento.toLowerCase()})
                  </Text>
                </span>
                {props.value.length - 1 !== index && <br />}
              </React.Fragment>
            );
          });
      },
    },
    {
      Header: "Serviço de Acolhimento",
      accessor: "servicoAcolhimento",
      sortType: (rowA, rowB, id, desc) => {
        const nomeServicoA = rowA?.original?.servicoAcolhimento
          ? rowA.original.servicoAcolhimento.nomeFantasia
          : "";
        const nomeServicoB = rowB?.original?.servicoAcolhimento
          ? rowB.original.servicoAcolhimento.nomeFantasia
          : "";
        return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
      },
      Cell: (props) => {
        const permissaoServico =
          roleKeycloack.includes(criancaFunc.visualizarTudo) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM
          ) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
          ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
            roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              props?.row?.original?.servicoAcolhimento?.idPessoaJuridica
            ));
        let temRiscoVida = false;

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        if (
          (props?.row?.original?.movimentacoes[0]?.riscoVidaMotivoSituacao ===
            "S" &&
            !permissaoServico) ||
          (!permissaoServico &&
            (props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 6) &&
            temRiscoVida)
        ) {
          return <span></span>;
        } else {
          const idServico = props?.row?.original?.servicoAcolhimento?.id;
          if (!idServico) {
            return <span></span>;
          } else {
            return (
              <>
                {roleKeycloack &&
                roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
                  <Link
                    wordBreak={"break-word"}
                    title={
                      props.value
                        ? props.value.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""
                    }
                    as={ReactLink}
                    to={"/servico-acolhimento/" + idServico}
                  >
                    <Text>
                      {" "}
                      {props.value
                        ? props.value.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""}
                    </Text>
                  </Link>
                ) : (
                  <Text>
                    {props.value
                      ? props.value.nomeFantasia +
                        `${props?.value?.suspenso === "S" ? " (Suspenso)" : ""}`
                      : ""}
                  </Text>
                )}
              </>
            );
          }
        }
      },
    },
    {
      Header: "Pendências",
      accessor: "descricaoTipoPendencia",
      Cell: (props) => {
        const pendencia = props?.value;
        const idAba = props?.row?.original?.idAba;
        const idTipoPendencia = props?.row?.original?.idTipoPendencia;
        const idCrianca = props?.row?.original?.idCrianca;
        const idPJ = props?.row?.original?.idPessoaJuridica;

        return (
          <Link
            onClick={() => {
              handleVerifyRedirectPendencia(
                idAba,
                idTipoPendencia,
                history,
                idCrianca,
                true,
                roleKeycloack,
                user,
                idPJ
              );
            }}
          >
            {pendencia ? pendencia : ""}
          </Link>
        );
      },
    },
    {
      Header: "Aba",
      accessor: "nomeAba",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
  ];

  useEffect(() => {
    let ignore = false;
    const getDadosCriancaDashboardPendencia = async () => {
      setLoading(true);

      const storage = JSON.parse(
        sessionStorage.getItem("crianca-pendencia-filter")
      );

      const valuesToSend = {
        pageSize: storage?.pageSize ? storage?.pageSize : "",
        page: storage?.page ? storage.page : "",
        sortField: storage?.sort ? storage?.sort : "servicoAcolhimento",
        sortType: storage?.desc ? storage?.desc : "ASC",
      };

      sessionStorage.setItem(
        "crianca-pendencia-filter",
        JSON.stringify({
          ...storage,
          sort: storage?.sort ?? "servicoAcolhimento",
          desc: storage?.desc ?? false,
        })
      );
      sessionStorage.setItem(
        "table-crianca",
        JSON.stringify([{ id: "servicoAcolhimento", desc: false }])
      );

      await CriancaService.getDashboardCriancaPendencias(valuesToSend)
        .then((res) => {
          if (ignore) return;
          sessionStorage.setItem("crianca-pendencia-filterSearch", true);
          const tempObj = JSON.parse(
            sessionStorage.getItem("crianca-pendencia-filter")
          );

          sessionStorage.setItem(
            "crianca-pendencia-filter",
            JSON.stringify({
              ...tempObj,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            })
          );
          setData(res.data);
        })
        .catch(() => {
          if (!ignore) setData([]);
        })
        .finally(() => {
          if (!ignore) setLoading(false);
        });
    };
    getDadosCriancaDashboardPendencia();
    return () => {
      ignore = true;
    };
  }, [selectedProfile, selectedOrgao]);

  const getExportarExecelRelatorio = async () => {
    const tempObj = JSON.parse(sessionStorage.getItem("table-crianca"));

    const valuesToSend = {
      dataReferencia: "",
      municipioId: 0,
      promocaoId: 0,
      servicoAtendimentoId: 0,
      tipoRelatorio: "LISTA_PENDENCIAS_CRIANCA_ADOLESCENTES",
      sortField: tempObj ? tempObj[0]?.id : "servicoAcolhimento",
      sortType: tempObj ? (tempObj[0]?.desc ? "DESC" : "ASC") : "ASC",
    };

    try {
      setLoadingExcel(true);
      await RelatorioService.getExecelListaRelatorio(valuesToSend);
      Swal.fire({
        title: "Em processamento",
        html: `<div style="text-align: center;">Este relatório está sendo processado em segundo plano. <br /> Para acompanhar, verifique a sua fila de processamento localizado no <br /> menu lateral do sistema.</div>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Ir para Fila de Processamento",
        cancelButtonText: "Fechar",
        width: "600px",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/fila-processamento");
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingExcel(false);
    }
  };

  const renderizarVisitas = () => {
    if (isMobile)
      return (
        <PopoverGenero
          isOpen={hintPreliminar}
          setIsOpen={setHintPreliminar}
          flex={true}
          handleClick={() => setHintPreliminar(!hintPreliminar)}
          labelTextoGenero={
            "Será exibida uma lista de pendências de crianças e adolescentes acolhidos em serviços de acolhimento na sua área de atuação."
          }
        />
      );

    return (
      <Tooltip
        label={
          "Será exibida uma lista de pendências de crianças e adolescentes acolhidos em serviços de acolhimento na sua área de atuação."
        }
        fontSize="md"
        maxW="400px"
        textAlign={"justify"}
        placement={placement}
      >
        <span className="hint-tooltip">
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize={{ base: "20px" }}
          />
        </span>
      </Tooltip>
    );
  };

  return (
    <Flex
      pt={"20px"}
      px={["5px", "30px"]}
      h="100%"
      flexDir="column"
      w="100%"
      maxW="2000px"
      overflow="auto"
      pb={["10px", "20px"]}
    >
      <Group
        title={
          <Flex>
            <Text textTransform="uppercase">
              Pendências Crianças e Adolescentes
            </Text>

            {roleKeycloack?.includes(
              servicoAcolhimentoFunc.visualizarParteMP
            ) && <> {renderizarVisitas()} </>}
          </Flex>
        }
        opcoes={true}
        voltar={true}
      >
        <Permission
          roleKeycloack={roleKeycloack}
          func={dashboardFunc.dashboardPendenciasCriancaExportar}
        >
          <Flex
            mt={6}
            alignItems="center"
            justifyContent="end"
            gap={2}
            cursor="pointer"
            onClick={() => !loadingExcel && getExportarExecelRelatorio()}
          >
            {loadingExcel ? (
              <Spinner size="sm" />
            ) : (
              <>
                <Flex bg="#006400" rounded="full" p={1}>
                  <RiFileExcel2Line color="white" />
                </Flex>

                <Text as="b" color="#006400" fontSize={"md"}>
                  Exportar em Excel
                </Text>
              </>
            )}
          </Flex>
        </Permission>

        {!loading ? (
          <>
            {data?.content && data?.content?.length > 0 ? (
              <TableCriancas
                data={data.content}
                columns={columns}
                entidade="crianca-pendencia"
                atualizarDadosTabela={atualizarDadosTabela}
                setAtualizarDadosTabela={setAtualizarDadosTabela}
                roleKeycloack={roleKeycloack}
                user={user}
                setData={setData}
                disableHeaderOptionsOpcoes
              />
            ) : (
              <Box>
                <SemRegistros half buttonVisible={true} />
              </Box>
            )}
          </>
        ) : (
          <>
            <LoadingSpinner />
          </>
        )}
      </Group>
    </Flex>
  );
}
